import { Avatar, Tag, Tooltip } from 'antd'
import { UserOutlined, RobotOutlined, AudioOutlined } from '@ant-design/icons'

export interface ChatMessage {
  id: string
  role: 'user' | 'ai'
  inputType: 'voice' | 'text'
  content: string
  asrText?: string
  audioBase64?: string
  audioFormat?: string
  backendUsed?: string
  latencyMs?: { asr?: number; llm?: number; tts?: number }
  timestamp: Date
}

interface Props {
  message: ChatMessage
  onPlayAudio?: (base64: string, format: string) => void
}

export function ChatBubble({ message, onPlayAudio }: Props) {
  const isUser = message.role === 'user'

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: isUser ? 'row-reverse' : 'row',
        alignItems: 'flex-start',
        gap: 10,
        marginBottom: 16,
      }}
    >
      <Avatar
        size={36}
        style={{
          background: isUser ? '#1677ff' : '#722ed1',
          flexShrink: 0,
        }}
        icon={isUser ? <UserOutlined /> : <RobotOutlined />}
      />
      <div style={{ maxWidth: '70%' }}>
        {message.asrText && (
          <div style={{ fontSize: 11, color: '#888', marginBottom: 4, textAlign: 'right' }}>
            <AudioOutlined /> ASR识别：{message.asrText}
          </div>
        )}
        <div
          style={{
            background: isUser ? '#1677ff' : '#f6f6f6',
            color: isUser ? '#fff' : '#333',
            borderRadius: isUser ? '12px 2px 12px 12px' : '2px 12px 12px 12px',
            padding: '10px 14px',
            fontSize: 14,
            lineHeight: 1.6,
            wordBreak: 'break-word',
          }}
        >
          {message.content}
        </div>
        <div
          style={{
            display: 'flex',
            gap: 6,
            marginTop: 4,
            justifyContent: isUser ? 'flex-end' : 'flex-start',
            flexWrap: 'wrap',
          }}
        >
          <span style={{ fontSize: 11, color: '#aaa' }}>
            {message.timestamp.toLocaleTimeString('zh-CN')}
          </span>
          {message.backendUsed && (
            <Tag color={message.backendUsed === 'local' ? 'green' : 'blue'} style={{ fontSize: 10, margin: 0 }}>
              {message.backendUsed === 'local' ? '本地模型' : '远程API'}
            </Tag>
          )}
          {message.latencyMs?.llm && (
            <Tooltip title={`LLM: ${message.latencyMs.llm}ms${message.latencyMs.asr ? ` | ASR: ${message.latencyMs.asr}ms` : ''}${message.latencyMs.tts ? ` | TTS: ${message.latencyMs.tts}ms` : ''}`}>
              <span style={{ fontSize: 11, color: '#aaa', cursor: 'default' }}>
                {Math.round((message.latencyMs.llm || 0) + (message.latencyMs.asr || 0))}ms
              </span>
            </Tooltip>
          )}
          {message.audioBase64 && onPlayAudio && (
            <span
              style={{ fontSize: 11, color: '#1677ff', cursor: 'pointer' }}
              onClick={() => onPlayAudio(message.audioBase64!, message.audioFormat || 'mp3')}
            >
              ▶ 播放回复
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
